import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import dayjs from "dayjs";
import Path from "app/route/Path";
import StepsBar from "app/components/common/StepsBar";
import Input from "app/components/common/Input";
import Button from "app/components/common/Button";
import Label from "app/components/common/Label";
import Panel from "app/components/common/Panel";
import Form from "app/components/common/Form";
import Api from "app/services/api";
import BackBtn from "../../BackButton";

function KitStockForm(props) {
  const { isEdit, stepId, children } = props;
  const kitStockHistoryItem = children;

  const [isSubmitting, setIsSubmitting] = useState(false);

  const steps = [
    { name: "在庫登録" },
    { name: "入力確認" },
    { name: "登録完了" },
  ];

  const navigate = useNavigate();

  const {
    handleSubmit,
    // handleChange,
    // errors,
    values,
    setFieldValue,
    // resetForm,
    // touched,
    // handleBlur,
  } = useFormik({
    initialValues: {
      inStockDate: isEdit
        ? dayjs(kitStockHistoryItem.inStockDate, "YYYY-MM-DD")
        : dayjs(),
      amount: isEdit ? kitStockHistoryItem.amount : 0,
      memo: isEdit ? kitStockHistoryItem.memo : "",
    },
    onSubmit: async (values) => {
      setIsSubmitting(true);
      const response = await (isEdit ? Api.kit.stock.histories.edit(kitStockHistoryItem.id, values) : Api.kit.stock.create(values));
      setIsSubmitting(false);
      gotoNextStep();
      // alert(JSON.stringify(values, null, 2));
      // setTimeout(() => {
      //   gotoNextStep();
      //   setIsSubmitting(false);
      // }, 1000);
    },
  });

  const gotoPrevStep = () => {
    isEdit
      ? navigate(Path.kit.stock.edit(kitStockHistoryItem.id, stepId - 1))
      : navigate(Path.kit.stock.create(stepId - 1));
  };

  const gotoNextStep = () => {
    isEdit
      ? navigate(Path.kit.stock.edit(kitStockHistoryItem.id, stepId + 1))
      : navigate(Path.kit.stock.create(stepId + 1));
  };

  const step1IsValid = () => {
    if (!values.inStockDate) {
      return false;
    }
    if (values.amount <= 0) {
      return false;
    }
    if (!values.memo) {
      return false;
    }

    return true;
  };

  const kitStockFinished = () => {
    navigate(Path.kit.stock.list);
  };

  const renderByStepIndex = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return (
          <>
            <Form.Row>
              <Form.Col>入荷日</Form.Col>
              <Form.ColGrow>
                <Input.DatePicker
                  disablePast
                  name="inStockDate"
                  className="w-full"
                  value={values.inStockDate}
                  setValue={(newValue) => {
                    setFieldValue("inStockDate", newValue);
                  }}
                ></Input.DatePicker>
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>入荷数</Form.Col>
              <Form.ColGrow>
                <Input.Field
                  name="amount"
                  type="number"
                  className="w-full"
                  value={values.amount}
                  setValue={(newValue) => {
                    setFieldValue("amount", newValue);
                  }}
                ></Input.Field>
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>備考</Form.Col>
              <Form.ColGrow>
                <Input.MultilineField
                  name="memo"
                  className="w-full"
                  value={values.memo}
                  setValue={(newValue) => {
                    setFieldValue("memo", newValue);
                  }}
                ></Input.MultilineField>
              </Form.ColGrow>
            </Form.Row>
            <Panel.Justify className="!sticky !bottom-0 w-full bg-white p-2">
              <BackBtn url={Path.kit.home}/>
              <Button.Primary onClick={gotoNextStep} disabled={!step1IsValid()}>
                次へ
              </Button.Primary>
            </Panel.Justify>
          </>
        );
      case 1:
        return (
          <div className="mx-2 space-y-4">
            <Form.Row>
              <Form.Col>入荷日</Form.Col>
              <Form.ColGrow>
                <Label.DateTime dateFormat="YYYY-MM-DD">
                  {values.inStockDate}
                </Label.DateTime>
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>数量</Form.Col>
              <Form.ColGrow>{values.amount}</Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>備考</Form.Col>
              <Form.ColGrow>
                <p className="whitespace-pre-wrap">{values.memo}</p>
              </Form.ColGrow>
            </Form.Row>
            <Panel.Justify className="!sticky !bottom-0 w-full bg-white p-2">
              <Button onClick={gotoPrevStep}>戻る</Button>
              <Button.Primary type="submit" loading={isSubmitting}>
                {isEdit ? "入荷情報を編集する" : "入荷情報を登録します"}
              </Button.Primary>
            </Panel.Justify>
          </div>
        );

      case 2:
        return (
          <div className="text-center space-y-4 mx-2">
            <Form.Row>
              <Form.ColGrow>
                {isEdit ? "入荷情報を編集しました" : "入荷情報を登録しました"}
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.ColGrow>
                <Button.Primary onClick={kitStockFinished}>完了</Button.Primary>
              </Form.ColGrow>
            </Form.Row>
          </div>
        );

      default:
        return <></>;
    }
  };

  return (
    <>
      <StepsBar steps={steps} currentStepIndex={stepId} />
      <Form.Form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
        {renderByStepIndex(stepId)}
      </Form.Form>
    </>
  );
}

export default KitStockForm;
